<template>
  <div>
    <div class="a-tab__title-block">
      <h3>{{$t('form.lot.delivery-dates')}}</h3>
    </div>

    <div class="admin-buy__block ">
      <section v-maximizable>
        <div class="table-tab">
        <div class="table-tab__container">
          <table class="table-tab__block table">
            <thead class="table-tab__thead">
              <tr class="">
                <th class="table-tab__border-bottom table-tab__th--row table-tab__border-right"></th>
                <th class="table-tab__border-bottom">
                  {{$t('form.lot.parts.date')}}
                </th>
                <th class="table-tab__border-bottom">
                  {{$t('form.lot.parts.date-in-bid')}}
                </th>
                <th class="table-tab__border-bottom">
                  {{$t('form.lot.start-date-of-stage-for-delivery')}}
                </th>
                <th class="table-tab__border-bottom">
                  {{$t('form.lot.start-date-of-stage-for-payment')}}
                </th>
              </tr>
            </thead>
            <tbody class="table-tab__tbody">
            <template v-for="(check, idx) in checks">
              <tr class="table-tab__border-bottom">
                <th class=" table-tab__th--row table-tab__border-bottom table-tab__border-right table-tab__btn-open">
                  <span class="table-tab__color u-padding-left-30">{{$t('form.lot.parts.part-number', {id: idx + 1})}}</span>
                </th>

                <td>
                  <label class="a-checkbox__label">
                    <input class="a-checkbox__input"
                           type="checkbox"
                           v-model="checks[idx]"
                           :disabled="!canEditNumberOfParts">
                    <span class="a-checkbox__icon"><i></i></span>
                  </label>
                </td>

                <td v-if="canEditNumberOfParts && checks[idx]">
                  <div class="a-form-field"
                       :class="{'a-form-field--error': $v.dates.$each[idx].$anyError}">
                    <date-picker v-model="dates[idx]"></date-picker>
                  </div>
                </td>
                <td v-else>
                  <date-time v-model="dates[idx]" :time="false"></date-time>
                </td>

                <td>
                  <date-time :time="false" :value="schedule[idx].minDeliveryDate"></date-time>
                </td>

                <td>
                  <date-time :time="false" :value="schedule[idx].minPaymentDate"></date-time>
                </td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
      </div>
      </section>
    </div>
  </div>
</template>

<script>
  import PermissionsMixins from '../mixins/permissions'

  export default {
    props: {
      lot: {
        type: Object,
        required: true
      }
    },

    mixins: [
      PermissionsMixins
    ],

    computed: {
      checks() {
        return this.lot.checkDates;
      },

      dates() {
        return this.lot.dates;
      },

      schedule() {
        return this.lot.deliverySchedule;
      }
    },

    created() {
      this.$v.$touch();
    },

    validations: {
      dates: {
        $each: {
          valid(value) {
            return !value || value >= new Date;
          }
        }
      }
    },
  }
</script>

<style scoped>

</style>
